(function () {
  'use strict';

  var started = false;
  var applying = false;
  var refreshTimer = null;
  var readyState = {
    hasReadyItems: window.AOW_CART_HAS_READY_STOCK_ITEMS === true,
    allReady: window.AOW_CART_READY_STOCK === true,
    mixed: window.AOW_CART_READY_STOCK_MIXED === true,
    fulfilment: normaliseFulfilment(window.AOW_READY_STOCK_FULFILMENT),
    cutoffHour: safeCutoff(window.AOW_READY_STOCK_CUTOFF_HOUR)
  };

  function safeCutoff(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 && parsed <= 23 ? parsed : 12;
  }

  function normaliseFulfilment(value) {
    return String(value || '').toLowerCase().indexOf('collection') !== -1 ? 'collection' : 'delivery';
  }

  function planner() { return document.getElementById('AowDeliveryPlanner'); }
  function checkoutButton() { return document.getElementById('checkout'); }
  function cartForm() { return document.getElementById('cart'); }
  function cartRoot() { return document.getElementById('main-cart-footer'); }
  function pad(value) { return String(value).padStart(2, '0'); }

  function londonNowParts() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var output = {};
    parts.forEach(function (part) { if (part.type !== 'literal') output[part.type] = Number(part.value); });
    return output;
  }

  function utcDate(year, monthIndex, day) { return new Date(Date.UTC(year, monthIndex, day)); }
  function todayDate() { var now = londonNowParts(); return utcDate(now.year, now.month - 1, now.day); }
  function addDays(date, days) { var copy = new Date(date.getTime()); copy.setUTCDate(copy.getUTCDate() + days); return copy; }
  function dateToIso(date) { return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()); }
  function formatOrderDate(date) { return new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }).format(date); }
  function formatLong(date) { return new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date); }
  function beforeReadyCutoff() { return londonNowParts().hour < readyState.cutoffHour; }
  function isToday(date) { return Boolean(date) && dateToIso(date) === dateToIso(todayDate()); }

  function blackoutDates(method) {
    var values = new Set();
    var config = window.AOW_DELIVERY_CONFIG || {};
    if (Array.isArray(config.blackoutDates)) config.blackoutDates.forEach(function (value) { values.add(String(value)); });
    var closures = window.AOW_DELIVERY_CLOSURES || {};
    var extra = method === 'collection' ? closures.collection : closures.delivery;
    if (Array.isArray(extra)) extra.forEach(function (value) { values.add(String(value)); });
    return values;
  }

  function isBlackout(date, method) { return blackoutDates(method).has(dateToIso(date)); }
  function deliveryAllowed(date) { return date.getUTCDay() !== 1 && !isBlackout(date, 'delivery'); }
  function collectionAllowed(date) { var weekday = date.getUTCDay(); return weekday >= 1 && weekday <= 5 && !isBlackout(date, 'collection'); }

  function nextEligible(start, allowed) {
    var candidate = start;
    var guard = 0;
    while (!allowed(candidate) && guard < 21) { candidate = addDays(candidate, 1); guard += 1; }
    return guard < 21 ? candidate : null;
  }

  function collectionTargetDate() {
    var candidate = beforeReadyCutoff() ? todayDate() : addDays(todayDate(), 1);
    return nextEligible(candidate, collectionAllowed);
  }

  function deliveryTargetDate() {
    var candidate = addDays(todayDate(), beforeReadyCutoff() ? 1 : 2);
    return nextEligible(candidate, deliveryAllowed);
  }

  function readyTarget() {
    return readyState.fulfilment === 'collection' ? collectionTargetDate() : deliveryTargetDate();
  }

  function fulfilmentAttribute(target) {
    if (readyState.fulfilment === 'collection') {
      return isToday(target) ? 'Collection Today' : 'Collection - ' + formatOrderDate(target);
    }
    return beforeReadyCutoff() ? 'Next-Day Delivery' : 'Fast Flowers Delivery - ' + formatOrderDate(target);
  }

  function itemReadyProperty(item) {
    var properties = item && item.properties ? item.properties : {};
    return String(properties['_AOW Ready Stock'] || properties['AOW Ready Stock'] || '').toLowerCase() === 'yes';
  }

  function itemFulfilmentProperty(item) {
    var properties = item && item.properties ? item.properties : {};
    return properties['_AOW Ready Stock Fulfilment'] || properties['AOW Ready Stock Fulfilment'] || '';
  }

  async function readCartState() {
    var response = await fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store'
    });
    if (!response.ok) throw new Error('Current basket could not be checked.');
    var cart = await response.json();
    var items = Array.isArray(cart.items) ? cart.items : [];
    var readyCount = items.filter(itemReadyProperty).length;
    var hasReadyItems = readyCount > 0;
    var allReady = hasReadyItems && readyCount === items.length;
    var mixed = hasReadyItems && readyCount < items.length;
    var attributes = cart.attributes || {};
    var lineMode = '';
    for (var index = 0; index < items.length; index += 1) {
      if (itemReadyProperty(items[index])) { lineMode = itemFulfilmentProperty(items[index]); if (lineMode) break; }
    }
    readyState.hasReadyItems = hasReadyItems;
    readyState.allReady = allReady;
    readyState.mixed = mixed;
    readyState.fulfilment = normaliseFulfilment(attributes['AOW Ready Stock Fulfilment'] || lineMode || readyState.fulfilment);
    readyState.cutoffHour = safeCutoff(attributes['AOW Ready Stock Cutoff Hour'] || readyState.cutoffHour);
    window.AOW_CART_HAS_READY_STOCK_ITEMS = hasReadyItems;
    window.AOW_CART_READY_STOCK = allReady;
    window.AOW_CART_READY_STOCK_MIXED = mixed;
    window.AOW_READY_STOCK_FULFILMENT = readyState.fulfilment === 'collection' ? 'Collection' : 'Delivery';
    return cart;
  }

  function addStyles() {
    if (document.getElementById('AowReadyStockCartStyles')) return;
    var style = document.createElement('style');
    style.id = 'AowReadyStockCartStyles';
    style.textContent = '#main-cart-footer .aow-ready-stock-cart-panel{padding:20px;border:1px solid rgba(82,109,93,.22);border-radius:13px;background:#eef5eb;color:#334c40}#main-cart-footer .aow-ready-stock-cart-panel__badge{display:inline-flex;padding:5px 9px;border-radius:999px;background:#334c40;color:#fff;font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase}#main-cart-footer .aow-ready-stock-cart-panel h3{margin:11px 0 6px;font:600 30px/1.08 Georgia,serif;color:#334c40}#main-cart-footer .aow-ready-stock-cart-panel p{margin:0;color:#607067;font-size:13px;line-height:1.55}#main-cart-footer .aow-ready-stock-cart-panel__options{display:grid;grid-template-columns:1fr;gap:9px;margin-top:16px}#main-cart-footer .aow-ready-stock-cart-mode{display:block;width:100%;padding:13px 14px;border:1px solid rgba(82,109,93,.25);border-radius:10px;background:#fff;color:#334c40;text-align:left;font:inherit;cursor:pointer}#main-cart-footer .aow-ready-stock-cart-mode strong{display:block;font-size:14px}#main-cart-footer .aow-ready-stock-cart-mode span{display:block;margin-top:3px;color:#6d7c75;font-size:11px;line-height:1.45}#main-cart-footer .aow-ready-stock-cart-mode.is-active{border-color:#334c40;background:#334c40;color:#fff}#main-cart-footer .aow-ready-stock-cart-mode.is-active span{color:#e9f0ec}#main-cart-footer .aow-ready-stock-cart-date{margin-top:14px;padding:12px;border-radius:9px;background:#fff;border:1px solid rgba(82,109,93,.15)}#main-cart-footer .aow-ready-stock-cart-date strong,#main-cart-footer .aow-ready-stock-cart-date span{display:block}#main-cart-footer .aow-ready-stock-cart-date span{margin-top:3px;font-size:11px;color:#68766f}#main-cart-footer .aow-ready-stock-mixed{margin:0 0 18px;padding:18px;border:1px solid #d8a49d;border-left:5px solid #a9473c;border-radius:11px;background:#fff2ef;color:#65332d}#main-cart-footer .aow-ready-stock-mixed strong{display:block;font-size:16px;margin-bottom:5px}#main-cart-footer .aow-ready-stock-mixed p{margin:0;font-size:13px;line-height:1.55}#main-cart-footer .aow-ready-stock-mixed a{display:inline-flex;margin-top:12px;padding:9px 12px;border-radius:8px;background:#65332d;color:#fff;text-decoration:none;font-size:12px;font-weight:800}#main-cart-footer .aow-calendar__day.is-aow-ready-target{outline:2px solid #334c40;outline-offset:-2px;background:#cfe1d5;color:#284338}';
    document.head.appendChild(style);
  }

  function mixedWarning() {
    var root = cartRoot(); if (!root) return null;
    var warning = document.getElementById('AowReadyStockMixedWarning');
    if (!warning) {
      warning = document.createElement('div');
      warning.id = 'AowReadyStockMixedWarning';
      warning.className = 'aow-ready-stock-mixed';
      warning.innerHTML = '<strong>Fast Flowers and standard products can’t be mixed.</strong><p>This basket contains both Fast Flowers and normal future-order products. Remove the standard items to continue with Fast Flowers, or start a standard order instead.</p><a href="/collections/all">Return to the full range</a>';
      var plannerNode = planner();
      if (plannerNode && plannerNode.parentNode) plannerNode.parentNode.insertBefore(warning, plannerNode);
      else if (root.querySelector('.page-width')) root.querySelector('.page-width').prepend(warning);
    }
    return warning;
  }

  function removeMixedWarning() { var warning = document.getElementById('AowReadyStockMixedWarning'); if (warning) warning.remove(); }

  function setCheckoutEnabled(enabled, message) {
    var button = checkoutButton(); if (!button) return;
    button.disabled = !enabled;
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    var status = document.getElementById('AowCheckoutStatus');
    if (!status) {
      status = document.createElement('p'); status.id = 'AowCheckoutStatus'; status.className = 'aow-checkout-status';
      var cta = button.closest('.cart__ctas'); if (cta) cta.appendChild(status);
    }
    if (status) { status.textContent = message || ''; status.classList.toggle('is-ready', enabled); }
  }

  function updateHiddenFields(target) {
    var methodInput = document.getElementById('AowMethodInput');
    var dateInput = document.getElementById('AowDateInput');
    var dateIsoInput = document.getElementById('AowDateIsoInput');
    var collectionTimeInput = document.getElementById('AowCollectionTimeInput');
    var eventDisplay = document.getElementById('AowEventDateDisplayInput');
    var eventIso = document.getElementById('AowEventDateIsoInput');
    if (methodInput) methodInput.value = readyState.fulfilment === 'collection' ? 'Collection' : 'Nationwide Delivery';
    if (dateInput) dateInput.value = target ? formatOrderDate(target) : '';
    if (dateIsoInput) dateIsoInput.value = target ? dateToIso(target) : '';
    if (collectionTimeInput) collectionTimeInput.value = '';
    if (eventDisplay) eventDisplay.value = '';
    if (eventIso) eventIso.value = '';
  }

  async function persistReadyAttributes(target) {
    var fulfilment = fulfilmentAttribute(target);
    var method = readyState.fulfilment === 'collection' ? 'Collection' : 'Nationwide Delivery';
    var attributes = {
      'AOW Event Date': '', 'AOW Event Date ISO': '', 'AOW Fulfilment Method': method,
      'AOW Requested Date': target ? formatOrderDate(target) : '', 'AOW Date ISO': target ? dateToIso(target) : '',
      'AOW Collection Time': '', 'AOW Ready Stock': 'Yes', 'AOW Ready Stock Fulfilment': fulfilment,
      'AOW Ready Stock Cutoff Hour': String(readyState.cutoffHour), 'AOW Next Day': 'Yes',
      'AOW Contains Plants': 'No', 'Shipping-Date': '', 'Checkout-Method': ''
    };
    var response = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin', body: JSON.stringify({ attributes: attributes })
    });
    if (!response.ok) throw new Error('Fast Flowers delivery details could not be saved.');
    return response.json();
  }

  function renderReadyCalendar(target) {
    var wrap = document.getElementById('AowCalendarWrap');
    var grid = document.getElementById('AowCalendarGrid');
    var month = document.getElementById('AowCalendarMonth');
    var prompt = document.getElementById('AowCalendarPrompt');
    var subtext = document.getElementById('AowCalendarSubtext');
    var prev = document.getElementById('AowCalendarPrev');
    var next = document.getElementById('AowCalendarNext');
    if (!wrap || !grid || !month || !target) return;
    wrap.classList.add('is-visible');
    var collection = readyState.fulfilment === 'collection';
    if (prompt) prompt.textContent = collection ? (isToday(target) ? 'Collection Today' : 'Your Fast Flowers collection date') : 'Your Fast Flowers delivery date';
    if (subtext) subtext.textContent = collection
      ? (isToday(target) ? 'Fast Flowers is available for collection today. We’ll confirm when your order is ready.' : 'Today’s collection cutoff has passed. This is the next eligible collection date.')
      : 'This is the next eligible Fast Flowers delivery date.';
    if (prev) prev.disabled = true;
    if (next) next.disabled = true;
    month.textContent = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(target);
    grid.innerHTML = '';
    var first = utcDate(target.getUTCFullYear(), target.getUTCMonth(), 1);
    var firstBlankCount = (first.getUTCDay() + 6) % 7;
    var daysInMonth = utcDate(target.getUTCFullYear(), target.getUTCMonth() + 1, 0).getUTCDate();
    var targetIso = dateToIso(target);
    for (var blankIndex = 0; blankIndex < firstBlankCount; blankIndex += 1) {
      var blank = document.createElement('span'); blank.className = 'aow-calendar__blank'; grid.appendChild(blank);
    }
    for (var day = 1; day <= daysInMonth; day += 1) {
      var date = utcDate(target.getUTCFullYear(), target.getUTCMonth(), day);
      var iso = dateToIso(date);
      var button = document.createElement('button');
      button.type = 'button'; button.textContent = day; button.dataset.date = iso;
      button.dataset.type = iso === targetIso ? 'available' : 'unavailable';
      button.className = 'aow-calendar__day ' + (iso === targetIso ? 'is-available is-selected is-aow-ready-target' : 'is-unavailable');
      button.setAttribute('aria-label', formatLong(date) + (iso === targetIso ? ' - Fast Flowers date' : ' - unavailable for this Fast Flowers order'));
      if (iso !== targetIso) button.disabled = true;
      grid.appendChild(button);
    }
  }

  function renderReadyPanel(target) {
    var root = planner(); if (!root || !target) return;
    root.classList.add('has-event'); root.dataset.aowReadyStock = 'true';
    var eventStep = root.querySelector('.aow-event-step');
    var fulfilmentStage = root.querySelector('.aow-fulfilment-stage');
    if (eventStep) eventStep.style.display = 'none';
    if (fulfilmentStage) fulfilmentStage.style.display = 'none';
    var side = root.querySelector('.aow-delivery-planner__side'); if (!side) return;
    var panel = document.getElementById('AowReadyStockCartPanel');
    if (!panel) { panel = document.createElement('div'); panel.id = 'AowReadyStockCartPanel'; panel.className = 'aow-ready-stock-cart-panel'; side.appendChild(panel); }

    var deliveryActive = readyState.fulfilment === 'delivery';
    var collectionActive = readyState.fulfilment === 'collection';
    var collectionTarget = collectionTargetDate();
    var deliveryTarget = deliveryTargetDate();
    var collectionToday = isToday(collectionTarget);
    var afterCutoff = !beforeReadyCutoff();
    var modeTitle = collectionActive ? (collectionToday ? 'Collection Today' : 'Next Collection') : (afterCutoff ? 'Next Available Delivery' : 'Next-Day Delivery');
    var dateCopy = (collectionActive ? 'Collection date: ' : 'Delivery date: ') + formatLong(target);

    panel.innerHTML = '<span class="aow-ready-stock-cart-panel__badge">Fast Flowers basket</span>' +
      '<h3>' + modeTitle + '</h3><p>Everything in this basket is Fast Flowers stock physically available with us now.</p>' +
      '<div class="aow-ready-stock-cart-panel__options">' +
      '<button type="button" class="aow-ready-stock-cart-mode ' + (deliveryActive ? 'is-active' : '') + '" data-aow-ready-mode="delivery"><strong>🚚 ' + (afterCutoff ? 'Next Available Delivery' : 'Next-Day Delivery') + '</strong><span>' + (afterCutoff ? 'Today’s 12pm cutoff has passed. Delivery will be ' + formatLong(deliveryTarget) + '.' : 'Order before 12pm for delivery on ' + formatLong(deliveryTarget) + '.') + '</span></button>' +
      '<button type="button" class="aow-ready-stock-cart-mode ' + (collectionActive ? 'is-active' : '') + '" data-aow-ready-mode="collection"><strong>🏪 ' + (collectionToday ? 'Collection Today' : 'Next Collection') + '</strong><span>' + (collectionToday ? 'Order before 12pm to collect today. Please wait for our ready confirmation before travelling.' : 'Today’s collection cutoff has passed. The next collection date is ' + formatLong(collectionTarget) + '.') + '</span></button>' +
      '</div><div class="aow-ready-stock-cart-date"><strong>' + dateCopy + '</strong><span>' + (collectionActive ? 'We’ll notify you when your flowers are ready for collection.' : 'This is the next eligible delivery date for this Fast Flowers basket.') + '</span></div>';

    panel.querySelectorAll('[data-aow-ready-mode]').forEach(function (button) {
      button.addEventListener('click', async function () {
        readyState.fulfilment = button.dataset.aowReadyMode === 'collection' ? 'collection' : 'delivery';
        window.AOW_READY_STOCK_FULFILMENT = readyState.fulfilment === 'collection' ? 'Collection' : 'Delivery';
        await applyReadyMode();
      });
    });
  }

  async function applyReadyMode() {
    if (applying || !readyState.allReady) return;
    applying = true;
    try {
      var target = readyTarget();
      if (!target) { setCheckoutEnabled(false, 'No eligible Fast Flowers date is currently available.'); return; }
      renderReadyPanel(target);
      renderReadyCalendar(target);
      updateHiddenFields(target);
      await persistReadyAttributes(target);
      setCheckoutEnabled(true, readyState.fulfilment === 'collection'
        ? 'Your Fast Flowers collection is set for ' + formatLong(target) + '. You can continue to checkout.'
        : 'Your Fast Flowers delivery is set for ' + formatLong(target) + '. You can continue to checkout.');
    } catch (error) {
      console.error('[AOW Ready Stock cart]', error);
      setCheckoutEnabled(false, error.message || 'Fast Flowers details could not be saved.');
    } finally { applying = false; }
  }

  function showMixedState() {
    addStyles(); mixedWarning();
    var root = planner();
    if (root) {
      root.dataset.aowReadyStockMixed = 'true';
      var eventStep = root.querySelector('.aow-event-step');
      var fulfilmentStage = root.querySelector('.aow-fulfilment-stage');
      var calendarWrap = document.getElementById('AowCalendarWrap');
      if (eventStep) eventStep.style.display = 'none';
      if (fulfilmentStage) fulfilmentStage.style.display = 'none';
      if (calendarWrap) calendarWrap.classList.remove('is-visible');
    }
    setCheckoutEnabled(false, 'Fast Flowers and standard products cannot be mixed in the same order.');
  }

  async function prepareShopifyCheckoutPreference() {
    var ajaxResponse = await fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    if (!ajaxResponse.ok) throw new Error('Could not read the current Shopify cart.');
    var ajaxCart = await ajaxResponse.json();
    var token = String(ajaxCart && ajaxCart.token ? ajaxCart.token : '').trim();
    if (!token) throw new Error('Shopify did not return a cart token.');
    var cartId = token.indexOf('gid://shopify/Cart/') === 0 ? token : 'gid://shopify/Cart/' + token;
    var isCollection = readyState.fulfilment === 'collection';
    var config = window.AOW_DELIVERY_CONFIG || {};
    var pickupLocationId = String(config.pickupLocationId || '69333680351');
    var delivery = { deliveryMethod: [isCollection ? 'PICK_UP' : 'SHIPPING'], pickupHandle: isCollection ? [pickupLocationId] : [] };
    var shop = String(window.Shopify && window.Shopify.shop ? window.Shopify.shop : '');
    if (!shop) throw new Error('Shopify store details could not be read.');
    var endpoint = 'https://' + shop + '/api/2026-07/graphql.json';
    var query = 'mutation AowReadyStockCheckout($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { id checkoutUrl } userErrors { field message code } warnings { code message target } } }';
    var response = await fetch(endpoint, {
      method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: query, variables: { cartId: cartId, buyerIdentity: { countryCode: 'GB', preferences: { delivery: delivery } } } })
    });
    if (!response.ok) throw new Error('Shopify checkout preference could not be prepared.');
    var payload = await response.json();
    var result = payload && payload.data ? payload.data.cartBuyerIdentityUpdate : null;
    var errors = [];
    if (Array.isArray(payload && payload.errors)) payload.errors.forEach(function (error) { if (error && error.message) errors.push(error.message); });
    if (result && Array.isArray(result.userErrors)) result.userErrors.forEach(function (error) { if (error && error.message) errors.push(error.message); });
    if (errors.length) throw new Error(errors.join(' '));
    if (!result || !result.cart || !result.cart.checkoutUrl) throw new Error('Shopify did not return a checkout URL.');
    return result.cart.checkoutUrl;
  }

  async function readyCheckout(event) {
    if (!readyState.hasReadyItems) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (readyState.mixed || !readyState.allReady) {
      showMixedState(); var plannerNode = planner(); if (plannerNode) plannerNode.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
    }
    var target = readyTarget();
    if (!target) { setCheckoutEnabled(false, 'No eligible Fast Flowers date is currently available.'); return; }
    var button = checkoutButton();
    var original = button ? button.textContent : '';
    if (button) { button.textContent = 'Preparing Fast Flowers checkout…'; button.disabled = true; button.setAttribute('aria-disabled', 'true'); }
    try {
      await persistReadyAttributes(target);
      var checkoutUrl = await prepareShopifyCheckoutPreference();
      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error('[AOW Ready Stock checkout]', error);
      window.location.assign('/checkout');
    } finally { if (button) button.textContent = original || 'Checkout'; }
  }

  function bindCheckout() {
    var button = checkoutButton(); var form = cartForm();
    if (button && button.dataset.aowReadyStockBound !== 'true') {
      button.dataset.aowReadyStockBound = 'true';
      button.addEventListener('click', function (event) { if (readyState.hasReadyItems) readyCheckout(event); }, true);
    }
    if (form && form.dataset.aowReadyStockBound !== 'true') {
      form.dataset.aowReadyStockBound = 'true';
      form.addEventListener('submit', function (event) { if (readyState.hasReadyItems) readyCheckout(event); }, true);
    }
  }

  async function refresh() {
    if (!planner()) return;
    try { await readCartState(); } catch (error) { console.warn('[AOW Ready Stock cart]', error); return; }
    bindCheckout();
    if (!readyState.hasReadyItems) return;
    addStyles();
    if (readyState.mixed || !readyState.allReady) { showMixedState(); return; }
    removeMixedWarning();
    await applyReadyMode();
  }

  function scheduleRefresh() { window.clearTimeout(refreshTimer); refreshTimer = window.setTimeout(refresh, 220); }
  function start() {
    if (started) return; started = true; refresh();
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('cart-items, #main-cart-items, .cart-items')) scheduleRefresh();
    });
    var observer = new MutationObserver(function (mutations) {
      var touchesCart = mutations.some(function (mutation) {
        var target = mutation.target;
        return target && target.nodeType === 1 && target.closest && target.closest('cart-items, #main-cart-items, .cart-items');
      });
      if (touchesCart) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else window.setTimeout(start, 0);
})();